export function isErrorResponseWithData(error: any) {
  return error.response && error.response.data;
}

export function errorString(error: any) {
  return isErrorResponseWithData(error) ? error.response.data : "unknown error";
}
